export interface Special {
  id: string;
  title: string;
  subtitle: string;
  cover: string;
  intro: string;
  reason: string;
  theme: string;
  dramaIds: string[];
  relatedIds: string[];
}

export const specials: Special[] = [
  {
    id: "special-current-hot",
    title: "当季热播精选",
    subtitle: "本季度口碑与人气兼具的热门作品",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20collage%20style%20banner%20with%20soft%20red%20and%20amber%20gradients%2C%20abstract%20film%20reel%20and%20spotlight%20motifs%2C%20elegant%20minimal%20entertainment%20theme%2C%20wide%20composition%2C%20high%20detail&width=1200&height=700&seq=special-current-hot-cover&orientation=landscape",
    intro:
      "为你汇集当前最受关注的剧集与综艺，从家庭情感到都市职场，从美食竞技到音乐舞台，一次看遍本季高光。",
    reason: "基于近期播放热度与观众讨论度综合精选，帮助你快速找到正在热播、值得追看的内容。",
    theme: "热播",
    dramaIds: ["kind-sister-in-law", "voice-of-future", "star-kitchen", "city-lights"],
    relatedIds: ["special-family-warmth", "special-classic"],
  },
  {
    id: "special-family-warmth",
    title: "家庭情感剧场",
    subtitle: "关于亲情与责任的温暖故事",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cozy%20family%20themed%20banner%20with%20soft%20cream%20and%20terracotta%20tones%2C%20abstract%20home%20and%20lantern%20motifs%2C%20heartwarming%20minimal%20design%2C%20wide%20composition%2C%20high%20detail&width=1200&height=700&seq=special-family-warmth-cover&orientation=landscape",
    intro:
      "从《善良的嫂子》到《欢乐一家人》，这些作品用最真实的烟火气，讲述平凡家庭里那些动人至深的情感。",
    reason: "以家庭、亲情为核心线索，挑选情感浓度高、口碑稳定的作品，适合与家人一同观看。",
    theme: "家庭",
    dramaIds: ["kind-sister-in-law", "happy-family", "mountain-echo"],
    relatedIds: ["special-current-hot", "special-classic"],
  },
  {
    id: "special-suspense",
    title: "高分悬疑剧场",
    subtitle: "烧脑反转，一次看个够",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20suspense%20themed%20banner%20with%20deep%20shadow%20and%20warm%20amber%20accents%2C%20abstract%20fog%20and%20geometric%20motifs%2C%20tense%20minimal%20design%2C%20wide%20composition%2C%20high%20detail&width=1200&height=700&seq=special-suspense-cover&orientation=landscape",
    intro:
      "层层反转的剧情、缜密扎实的推理，这些悬疑作品让你在紧张的氛围中一步步接近真相。",
    reason: "汇集推理逻辑严密、结局出人意料的悬疑佳作，适合喜欢烧脑挑战的观众。",
    theme: "悬疑",
    dramaIds: ["silent-witness", "fog-city-mystery"],
    relatedIds: ["special-current-hot", "special-classic"],
  },
  {
    id: "special-classic",
    title: "经典年代记忆",
    subtitle: "值得反复回味的时代画卷",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20vintage%20themed%20banner%20with%20sepia%20and%20warm%20clay%20tones%2C%20abstract%20old%20film%20strip%20and%20mountain%20motifs%2C%20retro%20elegant%20minimal%20design%2C%20wide%20composition%2C%20high%20detail&width=1200&height=700&seq=special-classic-cover&orientation=landscape",
    intro:
      "跨越数十年的时代故事，讲述普通人在历史洪流中的命运沉浮，每一帧都值得细细品味。",
    reason: "甄选制作精良、时代氛围浓厚的年代作品，展现大时代中的人情冷暖。",
    theme: "年代",
    dramaIds: ["mountain-echo", "long-night-clear", "chasing-light"],
    relatedIds: ["special-family-warmth", "special-suspense"],
  },
];